<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card class="pa-0" flat>
        <v-card-text>
            <v-container fluid class="pa-2">
                <v-row dense>

                    <v-col cols="2" class="text-left">
                        <help-icon help="edit-panelist-timeline"></help-icon>
                    </v-col>

                    <v-col cols="10" class="text-right">

                        <v-btn-toggle rounded v-model="filters" mandatory multiple>
                            <v-btn text value="email">
                                Emails
                            </v-btn>
                            <v-btn text value="start">
                                Starts
                            </v-btn>
                            <v-btn text value="termination">
                                Terminations
                            </v-btn>
                            <v-btn text value="completed">
                                Completed
                            </v-btn>
                            <v-btn text value="reward">
                                Reward
                            </v-btn>
                            <v-btn text value="redemption">
                                Redemption
                            </v-btn>
                            <v-btn text value="subscription">
                                Subscription
                            </v-btn>
                            <v-btn text value="password">
                                Password
                            </v-btn>
                            <v-btn text value="security">
                                Security
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                    <v-col cols="12">
                        <v-container fluid class="pa-2">
                            <v-row row>
                                <v-col cols="12">

                                    <v-timeline>
                                        <v-timeline-item
                                            dark
                                            v-for="(event, i) in timeLineData"
                                            :color="event.color"
                                            :icon="event.icon ? event.icon : null"
                                            :key="i">
                                            <template v-slot:opposite>
                                                <div class="subtitle-2 white--text font-weight-light">
                                                    <div v-if="event.display === 'date'">
                                                        {{ toLocalDate(event.date) }}
                                                    </div>
                                                    <div v-else>
                                                        {{ toLocalDateTime(event.date) }}
                                                    </div>
                                                </div>
                                            </template>

                                            <v-card class="elevation-2" color="grey darken-2">
                                                <div
                                                    :class="`pa-3 headline white--text`">
                                                    {{ event.headline }}
                                                </div>
                                                <v-card-text>
                                                    {{ event.description }}
                                                </v-card-text>
                                            </v-card>

                                        </v-timeline-item>
                                    </v-timeline>

                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

        <v-card-text>
            <v-container fluid class="pa-2">
                <v-row row>
                    <v-col cols="12">
                        <json v-if="debug" :data="data.activity_history"></json>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

    </v-card>
</template>

<script>

import {timeDisplay} from '../../../../components/mixins/timeDisplayMixin';
import Json from 'vue-json-pretty';
import moment from 'moment/moment';
import {mapState, mapMutations} from 'vuex';
import TitleCard from "../../../../components/UI/TitleCard";
import HelpIcon from "../../../../components/UI/HelpIcon";
import {statusColorMixin} from "../../../../components/mixins/statusColorMixin";

export default {

    mixins: [timeDisplay, statusColorMixin],

    components: {
        HelpIcon,
        Json,
        TitleCard
    },

    props: {
        data: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            debug: false
        }
    },

    computed: {

        ...mapState('PanelistManager', [
            'timeLineFilters',
        ]),

        filters: {
            get() {
                return this.timeLineFilters;
            },
            set(filters) {
                this.setTimeLineFilters(filters);
            }
        },

        timeLineData() {
            if (this.data.data_variables) {

                let timeLineData = [];

                // SUBSCRIBED_DATE
                const subscribedDate = this.data.data_variables.find(item => item.dataVariable.uuid === '3PceiALrSPB7Lv8Fya5ST2');

                if (subscribedDate) {
                    timeLineData.push({
                        color: 'green',
                        description: 'Panelist first joined the panel! The journey started from here.',
                        headline: 'Joined panel',
                        date: subscribedDate.recorded_value + ' 00:00:00',
                        type: 'subscription',
                        display: 'date',
                        icon: 'mdi-account-check'
                    });
                }

                // UNSUBSCRIBED_DATE
                const unsubscribedDate = this.data.data_variables.find(item => item.dataVariable.uuid === '6YIHCtpzuU7z7zplxUju2C');

                // BLACKLISTED_DATE
                const blackListedDate = this.data.data_variables.find(item => item.dataVariable.uuid === '5PerQOf99koSq3uNFgLZHo');

                if (blackListedDate) {
                    timeLineData.push({
                        color: 'black',
                        description: 'Panelist was blacklisted and can no longer receive email invitations or access the community',
                        headline: 'Blacklisted',
                        date: blackListedDate.recorded_value + ' 23:59:59',
                        display: 'date',
                        type: 'subscription',
                        icon: 'mdi-account-off',
                    });
                } else if (unsubscribedDate) {
                    timeLineData.push({
                        color: 'red',
                        description: 'You have lost a panelist here. Analyse what could have gone wrong and improve you engagement strategies',
                        headline: 'Unsubscribed from the panel',
                        date: unsubscribedDate.recorded_value + ' 23:59:58',
                        type: 'subscription',
                        display: 'date',
                        icon: 'mdi-account-minus'
                    });
                }

                this.data.activity_history.forEach(activity => {

                    if (activity.type === "Project") {
                        if (activity.status === 'invited') {
                            timeLineData.push({
                                color: this.statusColors.invited,
                                description: 'Panelist has been invited to project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Invited to project',
                                date: activity.created_at,
                                type: 'email',
                                display: 'dateTime',
                                icon: 'mdi-email-outline',
                            });
                        }
                        if (activity.status === 'reminded') {
                            timeLineData.push({
                                color: this.statusColors.reminded,
                                description: 'Panelist has been sent a reminder to participate in project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Reminder sent',
                                date: activity.created_at,
                                type: 'email',
                                display: 'dateTime',
                                icon: 'mdi-email-outline',
                            });
                        }
                        if (activity.status === 'opened') {
                            timeLineData.push({
                                color: this.statusColors.opened,
                                description: 'Read the email invitation sent out to participate in project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Read invitation',
                                date: activity.created_at,
                                type: 'email',
                                display: 'dateTime',
                                icon: 'mdi-email-open-outline',
                            });
                        }
                        if (activity.status === 'started') {
                            timeLineData.push({
                                color: this.statusColors.started,
                                description: 'Started participating in project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Started project ',
                                date: activity.created_at,
                                type: 'start',
                                display: 'dateTime',
                                icon: 'mdi-arrow-right-drop-circle-outline'
                            });
                        }
                        if (activity.status === 'profile') {
                            timeLineData.push({
                                color: this.statusColors.profile,
                                description: 'Panelist disqualified in project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Profile terminated',
                                date: activity.created_at,
                                type: 'termination',
                                display: 'dateTime',
                                icon: 'mdi-stop-circle',
                            });
                        }
                        if (activity.status === 'quota') {
                            timeLineData.push({
                                color: this.statusColors.quota,
                                description: 'Panelist quota terminated in project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Quota terminated ',
                                date: activity.created_at,
                                type: 'termination',
                                display: 'dateTime',
                                icon: 'mdi-stop-circle',
                            });
                        }

                        if (activity.status === 'quality') {
                            timeLineData.push({
                                color: this.statusColors.quality,
                                description: 'Panelist terminated because of quality in project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Disqualified due to quality',
                                date: activity.created_at,
                                type: 'termination',
                                display: 'dateTime',
                                icon: 'mdi-stop-circle',
                            });
                        }

                        if (activity.status === 'duplicate') {
                            timeLineData.push({
                                color: this.statusColors.duplicate,
                                description: 'Panelist terminated as duplicate in project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Disqualified due to being duplicate',
                                date: activity.created_at,
                                type: 'termination',
                                display: 'dateTime',
                                icon: 'mdi-stop-circle',
                            });
                        }

                        if (activity.status === 'security') {

                            let flagsString = null;

                            if (activity.flags) {
                                flagsString = '(' + activity.flags.join(',') + ')';
                            }

                            timeLineData.push({
                                color: this.statusColors.security,
                                description: 'Panelist terminated to security ' + flagsString + ' in project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Security violation',
                                date: activity.created_at,
                                type: 'termination',
                                display: 'dateTime',
                                icon: 'mdi-stop-circle',
                            });
                        }

                        if (activity.status === 'completed') {
                            timeLineData.push({
                                color: this.statusColors.completed,
                                description: 'Congrats this panelist completed project: ' + activity.name + ' (' + activity.id + ')',
                                headline: 'Completed project!',
                                date: activity.created_at,
                                type: 'completed',
                                display: 'dateTime',
                                icon: 'mdi-star'
                            });
                        }

                    } else if (activity.type === 'Redemption') {

                        let description = 'Panelist redeemed ' + activity.cost + ' reward points';

                        if (activity.name) {
                            description += ' for ' + activity.name;
                        }

                        timeLineData.push({
                            color: 'teal',
                            description: description,
                            headline: 'Redemption',
                            date: activity.created_at,
                            type: 'redemption',
                            display: 'dateTime',
                            icon: 'mdi-wallet-giftcard',
                        });

                    } else if (activity.type === 'RegistrationSurvey') {

                        timeLineData.push({
                            color: 'green',
                            description: 'Panelist completed the registration survey',
                            headline: 'Completed registration survey',
                            date: activity.created_at,
                            type: 'subscription',
                            display: 'dateTime',
                            icon: 'mdi-head-question',
                        });

                    } else if (activity.type === 'ImportBalance') {

                        timeLineData.push({
                            color: 'green',
                            description: "Panelist's point balance (" + activity.reward + ") was imported",
                            headline: 'Received imported balance',
                            date: activity.created_at,
                            type: 'subscription',
                            display: 'dateTime',
                            icon: 'mdi-currency-sign',
                        });

                    } else if (activity.type === 'Password') {

                        timeLineData.push({
                            color: 'primary',
                            description: "Panelist has successfully gone through " + activity.status + ' procedure!',
                            headline: 'Password was ' + activity.status,
                            date: activity.created_at,
                            type: 'password',
                            display: 'dateTime',
                            icon: 'mdi-security',
                        });
                    } else {
                        console.error("Timeline does not know how to handle " + activity.type);
                    }
                });

                this.data.reward_history.forEach(reward => {

                    let description = '';

                    if (reward.rewardable && reward.rewardable_type === "Project") {
                        description += ' For completing project: ' + reward.rewardable.name + ' (' + reward.rewardable.id + ')';
                    }

                    timeLineData.push({
                        color: 'orange',
                        headline: 'Reward points issued',
                        description: 'Total of ' + reward.reward + ' Reward Points issued. ' + description,
                        date: moment(reward.created_at).add(1, "second"),
                        type: 'reward',
                        display: 'dateTime',
                        icon: 'mdi-currency-usd',
                    });
                });

                timeLineData = timeLineData.filter(item => item.type && this.filters.includes(item.type));

                // Re-sort by timestamp
                return timeLineData.sort((a, b) => {

                    return moment.utc(a.date).unix() > moment.utc(b.date).unix() ? -1 : 1;
                });
            }

            return [];
        }
    },

    methods: {
        ...mapMutations('PanelistManager', [
            'setTimeLineFilters'
        ])
    }
}
</script>
